// Multivariate Dependencies
import React from 'react';
export var DividerStructure = function (_a) {
    var orientation = _a.orientation, className = _a.className;
    return (React.createElement("div", { role: 'separator', className: className, "aria-orientation": orientation }));
};
//# sourceMappingURL=DividerStructure.js.map